import reducer from './slips.reducer';
import * as selector from './slips.selector';
import * as constant from './slips.constant';
import subscriber from './slips.subscriber';
import saga from './slips.saga';

export default {
  reducer,
  constant,
  selector,
  name: constant.NAME,
  subscriber,
  saga,
};
